import React, { PropTypes } from 'react';
import Select, { Creatable } from 'react-select';
import DatePicker from "react-datepicker";
import moment from 'moment';

import { selectify } from "../../businessLogic/util";

export default class Metadata extends React.Component {	

	componentWillMount() {
		this.props.getAuthors();
		this.props.getInstitutions();
		this.props.getThemes();
		this.props.getKeywords();
		if (this.props.document.projects.length > 0) {
			this.props.getFolders(this.props.document.projects[0].id);
		}
	}

	render () {		
		const { actions, document, domains } = this.props;
		return (			
			<form>
				<div className="row" style={{paddingTop: "15px"}}>
					<div className="col-md-6">
						<div className="form-group">
							<label>Título</label>
							<input 
								type="text" 
								className="form-control"
								value={document.title}
								onChange={(e) => actions.setTitle(e.target.value)}
							/>
						</div>
						<div className="form-group">
							<label>Autores</label>
							<Creatable
								name="authors-select"
								multi
								value={document.authors}							
								options={selectify(domains.authors.list)}								
								noResultsText="Nenhum resultado encontrado"
								placeholder="Selecione..."								
								clearable={false}
								onChange={(value) => actions.setAuthors(value)}
							/>							
						</div>
						<div className="form-group">
							<label>Instituições</label>
							<Creatable
								name="institutions-select"																					
								options={selectify(domains.institutions.list)}
								value={document.institutions}													
								placeholder="Selecione..."
								multi								
								clearable={false}
								onChange={(value) => actions.setInstitutions(value)}
							/>							
						</div>
						<div className="form-group">
							<label>Link para o Documento</label>
							<input 
								type="text" 
								className="form-control"
								value={document.url === null ? "" : document.url}								
								onChange={(e) => actions.setUrl(e.target.value)}
							/>
						</div>								
						<div className="form-group">
							<label>Data da Última Modificação</label>
							<br />
							<DatePicker
								onChange={(option) => actions.setDatetime(option ? moment(option).format("YYYY-MM-DD") : null)}
								selected={document.datetime ? moment(document.datetime) : null}						
								locale="pt-BR"
								todayButton={"Hoje"}
								dateFormat="DD/MM/YYYY"		
								className="neocafe-datepicker"					
								placeholderText="DD/MM/YYYY" />
						</div>
						<div className="form-group">
							<label>Cobertura Temporal</label>
							<br />
							De &nbsp;
							<DatePicker
								onChange={(option) => actions.setStartCoverageDate(option ? moment(option).format("YYYY-MM-DD") : null)}
								selected={document.startCoverageDate ? moment(document.startCoverageDate) : null}						
								locale="pt-BR"
								todayButton={"Hoje"}
								dateFormat="DD/MM/YYYY"	
								className="neocafe-datepicker"
								placeholderText="DD/MM/YYYY" />
							&nbsp; Até &nbsp;					
							<DatePicker
								onChange={(option) => actions.setEndCoverageDate(option ? moment(option).format("YYYY-MM-DD") : null)}
								selected={document.endCoverageDate ? moment(document.endCoverageDate) : null}						
								locale="pt-BR"
								todayButton={"Hoje"}
								dateFormat="DD/MM/YYYY"		
								className="neocafe-datepicker"					
								placeholderText="DD/MM/YYYY" />
						</div>						
					</div>
					<div className="col-md-6">
						<div className="form-group">
							<label>Pasta</label>
							<Creatable
								name="folders-select"																					
								options={selectify(domains.folders.list)}
								value={document.folder}													
								placeholder="Selecione..."								
								onChange={(value) => actions.setFolder(value)}
							/>							
						</div>					
						<div className="form-group">
							<label>Temas</label>
							<Select
								name="themes-select"																					
								options={selectify(domains.themes.list)}
								value={document.themes}													
								placeholder="Selecione..."
								multi								
								clearable={false}
								onChange={(value) => actions.setThemes(value)}
							/>							
						</div>
						<div className="form-group">
							<label>Palavras-Chave</label>
							<Creatable
								name="keywords-select"																					
								options={selectify(domains.keywords.list)}
								value={document.keywords}													
								placeholder="Selecione..."
								multi								
								clearable={false}
								onChange={(value) => actions.setKeywords(value)}
							/>							
						</div>
						<div className="form-group">
							<label>Descrição</label>
							<textarea 
								rows={9}						
								style={{width: "100%", resize: "none"}}
								value={document.description} 
								onChange={(e) => actions.setDescription(e.target.value)} />
						</div>						
					</div>													
				</div>
			</form>
		);
	}
}

Metadata.propTypes = {
	actions: PropTypes.object.isRequired,
	document: PropTypes.object.isRequired,
	domains: PropTypes.object.isRequired,
	getFolders: PropTypes.func.isRequired,
	getAuthors: PropTypes.func.isRequired,
	getKeywords: PropTypes.func.isRequired,
	getThemes: PropTypes.func.isRequired,
	getInstitutions: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/Metadata.js